// Copyright (c) 2016 Deere & Company

import './date-range-picker.scss';
import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import DateRange from '@deere/cps-it.warranty-model-factory/lib/date-range';
import OptionsDropDown from '../../options-drop-down';
import WarrantyDateRangePicker from '../../warranty-date-range-picker/warranty-date-range-picker';
import {translate} from '../../../services/translation-service';

const FacetsDateRangePickerOptionsControlled = props => {

    const accordionBody = (
        <section className='facets-date-range-options'>
            <OptionsDropDown
                className={props.className}
                isPlaceholderTranslated={props.isPlaceholderTranslated}
                onChange={props.onChange}
                optionDisplayAttributes={props.optionDisplayAttributes}
                optionKey={props.optionKey}
                options={props.options}
                placeholder={props.placeholder}
                selectedValue={props.selectedValue}
            />
            <WarrantyDateRangePicker
                dateRange={props.dateRange}
                maxDate={props.maxDate}
                minDate={props.minDate}
                onDateChange={props.onDateChange}
            />
        </section>
    );

    return (
        <Accordion
            accordionId='date-range-picker-accordion'
            body={accordionBody}
            isExpanded={props.isExpanded}
            onClick={props.onClick}
            title={translate(props.title)}
        />
    );

};

FacetsDateRangePickerOptionsControlled.displayName = 'FacetsDateRangePickerOptionsControlled';
FacetsDateRangePickerOptionsControlled.propTypes = {
    className: PropTypes.string.isRequired,
    dateRange: PropTypes.instanceOf(DateRange),
    isExpanded: PropTypes.bool.isRequired,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    maxDate: PropTypes.number,
    minDate: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf(PropTypes.string).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    placeholder: PropTypes.string.isRequired,
    selectedValue: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default FacetsDateRangePickerOptionsControlled;



// WEBPACK FOOTER //
// ./src/shared/components/facets/date-range-picker-options/controlled.js